<template>
	<div class="dtxwNew">
		<ul>
			<li
				v-for="(item, index) in dataList"
				:key="item.ID"
				@mouseenter="hoverRoll(item)"
				class="wow fadeInLeft"
				:data-wow-delay="index / 6 + 's'"
			>
				<router-link
				:to="item.Url"
				:href="item.Url"
				@click.native="OpenLink(item.Url)"
				class="flexDiv">
				<div class="dtxwNew_img">
					<img :src="item.Cover" alt="">
				</div>
				<div class="textBox">
                    <div class="dtxwNew_text flexDiv">
                        <h3 class="title txt-cut1">{{ item.Title }}</h3>
                        <span>{{ setTimeformat(item.ShowTime6, "yyyy-mm-dd") }}</span>
                    </div>
                    <p class="txt-cut4">{{ item.Describe }}</p>
				</div>
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		name:'dtxwList',
		props:{
			dataList:{
				type: Array,
				default: () => []
			},
			moreLink: {
			   type: String,
			   default: ''
			}
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			    this.item = _data
			}
		}
	}
</script>

<style lang='less' scoped>
.dtxwNew {
  width: 1200px;
  ul {
  width: 1200px;
  height: auto;
  li{
	  width: 1200px;
	  height: 200px;
	  background-color: #fbfbfb;
	  margin: 0;
	  margin-bottom: 30px;
      box-sizing: border-box;
	  &:last-child{
		  margin-bottom: 0px;
	  }
      &:hover{
        .textBox{
            .dtxwNew_text{
                h3{
                    color: #3891E6;
                }
            }
        }
      }
	  .dtxwNew_img{
		  width: 290px;
          height: 200px;
          background-color: #f8f8f8;
          margin: 0;
          img{
              margin: 0;
              width: 100%;
              height: 100%;
              display: block;
          }
	  }
	  .textBox{
          width: 910px;
          padding: 30px;
          height: auto;
          box-sizing: border-box;
          .dtxwNew_text{
              width: 100%;
              height: 34px;
            h3{
                width: 500px;
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 24px;
                color: #333333;
                display: block;
            }
            span{
                font-size: 18px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 24px;
                letter-spacing: 2px;
                color: #999999;
                display: block;
            }
          }
            p{
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 26px;
                color: #666666;
            }
	  }
	}
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dtxwList.vue